<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import TENKENGYOUMU_BASE from 'src/consts/tenkengyoumu_base'
import TENKENGYOUMU_DETAIL from 'src/consts/tenkengyoumu_detail'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import tenkenKubunApi from 'src/apis/masters/tenken_kubun'

const api = tenkenKubunApi
const displayPageName = '点検区分'
const msgVars = { create: '作成', update: '編集' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,

      search: {
        tenkengyoumuBaseId: null,
        tenkengyoumuDetailId: null,
      },
      origList: [],
      list: [],
      tenkengyoumuBaseCands: [],
      origTenkengyoumuDetailCands: [],
      tenkengyoumuDetailCands: [],
      saveCandidate: {},
      showSaveModal: false,
      showPasswordModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    this.prepareMasters()
    this.prepareSearchParams()
    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin],
  methods: {
    prepareMasters() {
      const master = window.master
      this.tenkengyoumuBaseCands = master.tenkengyoumu_base.vals
      this.origTenkengyoumuDetailCands = master.tenkengyoumu_detail.vals
    },
    prepareSearchParams() {
      const search = {
        tenkengyoumuBaseId: null,
        tenkengyoumuDetailId: null,
      }
      if (this.tenkengyoumuBaseCands.length > 0) {
        search.tenkengyoumuBaseId = this.tenkengyoumuBaseCands[0].m_tenkengyoumu_base_id
      }
      if (this.origTenkengyoumuDetailCands.length > 0) {
        search.tenkengyoumuDetailId = this.origTenkengyoumuDetailCands[0].m_tenkengyoumu_detail_id
      }
      this.search = search
      this.filterTenkengyoumuDetail()
    },
    filterListBySearchParams() {
      this.pagination.currentPage = 1
      this.list = this.origList.filter(e => {
        return (e.tenkengyoumu_base_id === this.search.tenkengyoumuBaseId) &&
          (e.tenkengyoumu_detail_id === this.search.tenkengyoumuDetailId)
      })
    },
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await tenkenKubunApi.index()
        this.origList = data
        this.filterListBySearchParams()
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    filterTenkengyoumuDetail() {
      const tenkengyoumuBaseId = parseInt(this.search.tenkengyoumuBaseId)
      const isRojou = tenkengyoumuBaseId === TENKENGYOUMU_BASE.ROJOU
      const isRoka = tenkengyoumuBaseId === TENKENGYOUMU_BASE.ROKA
      const isKoukashita = tenkengyoumuBaseId === TENKENGYOUMU_BASE.KOUKASHITA
      this.tenkengyoumuDetailCands = this.origTenkengyoumuDetailCands.filter(e => {
        const detailGyoumuId = parseInt(e.m_tenkengyoumu_detail_id)
        if (isRojou || isRoka) {
          return (detailGyoumuId === TENKENGYOUMU_DETAIL.DOBOKU) ||
            (detailGyoumuId === TENKENGYOUMU_DETAIL.SHISETSU_DENKI)
        } else if (isKoukashita) {
          return detailGyoumuId === TENKENGYOUMU_DETAIL.KOUKASHITA
        }
      })

      let tenkengyoumuDetail = this.tenkengyoumuDetailCands.find(e => {
        return e.m_tenkengyoumu_detail_id === this.search.tenkengyoumuDetailId
      })
      if (!tenkengyoumuDetail) {
        tenkengyoumuDetail = this.tenkengyoumuDetailCands[0]
        this.search.tenkengyoumuDetailId =
          tenkengyoumuDetail ? tenkengyoumuDetail.m_tenkengyoumu_detail_id : null
      }
      this.filterListBySearchParams()
    },
    openSaveModal(item) {
      let saveCandidate = {}
      if (!item) {
        saveCandidate.isNew = true
        saveCandidate.tenkengyoumu_base_id = this.search.tenkengyoumuBaseId
        saveCandidate.tenkengyoumu_detail_id = this.search.tenkengyoumuDetailId
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        saveCandidate.start_date = today
        saveCandidate.end_date = new Date(2099, 12 - 1, 30)
      } else {
        saveCandidate = JSON.parse(JSON.stringify(item))
      }
      this.saveCandidate = saveCandidate
      this.showSaveModal = true
    },
    closeSaveModal() {
      this.saveCandidate = {}
      this.showSaveModal = false
    },
    async saveItem() {
      const isValid = await this.$refs.saveCandidate.validate()
      if (!isValid) { return }
      const opType = this.saveCandidate.isNew ? 'create' : 'update'
      try {
        const reqObj = {
          id: this.saveCandidate.id,
          data: this.saveCandidate,
        }
        await api[opType](reqObj)
        await this.getList()
        this.closeSaveModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}しました`)
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
